

import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

import axios from 'axios'
import VueAxios from 'vue-axios'

import actualidadModule from '@/store/actualidad'
import formulariosModule from '@/store/formularios'
import contratacionesModule from '@/store/contratacion'
import autoconsumoModule from '@/store/autoconsumo'
import googlePlacesModule from '@/store/googlePlaces'

import VeeValidate, {Validator} from 'vee-validate';
import validatorEs from '@/validator/es';
import validatorEn from '@/validator/en';
import veeLocaleEs from 'vee-validate/dist/locale/es';
import veeLocaleEn from 'vee-validate/dist/locale/en';
import fields from '@/translations/fields';

import messages from '@/translations';

// let server = (location.hostname.includes('inerenergia.es')) ? 'https://back.inerenergia.es' : 'https://dmb_iner.dev.doubledot.es/';
// let server = 'https://dmb_iner.dev.doubledot.es/';
let server = 'https://back.inerenergia.es'; 
//server = 'http://localhost:8000';


export const store = new Vuex.Store({
  state :{
    language: 'es',
    server : server,
    proyecto : 'Iner',
    horario : 'invierno',
  },
  actions :{
    changeLanguage : ({commit}, actualLang) => {
      return new Promise((resolve, reject) => {
        let nextLang = (actualLang == "es") ? "en" : "es";
        commit('setLanguage', nextLang);
        switch (nextLang) {
          case "es":
          Validator.localize('es', {
            ...veeLocaleEs,
            custom: {
              ...(veeLocaleEs.custom || {}),
              ...(validatorEs.custom || {})
            },
            attributes: {
              ...(veeLocaleEs.attributes || {}),
              ...(fields.es || {})
            },
          });
          break;
          case "en":
          Validator.localize('en', {
            ...veeLocaleEn,
            custom: {
              ...(veeLocaleEn.custom || {}),
              ...(validatorEn.custom || {})
            },
            attributes: {
              ...(veeLocaleEn.attributes || {}),
              ...(fields.en || {})
            },
          });
          break;
        }
        resolve(nextLang);
      });
    },
    sendErrorToSlack :({getters},text) =>{
      // if(location.hostname != 'localhost'){

        var time = new Date();


        let data;
        data = '----------------------------------------\n';
        data += `ERROR en ${getters.getProyecto}\n`;
        data += 'Hora del error:\n'+time.toTimeString()+'\n';
        data += 'Mensaje:\n'+text+'\n';
        data += '----------------------------------------';

        data = {"text" : data};

        let url = 'https://hooks.slack.com/services/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';

        var xhr = new XMLHttpRequest();
        xhr.open("POST", url, true);
        xhr.send(JSON.stringify(data));
      // }
    },
  },
  getters : {
    getLanguage : state => state.language,
    getServer : state => state.server,
    getProyecto : state => state.proyecto,
    getTexts : state => {
      return messages[state.language];
    },
    gethorario : state => {
      let horario; 
      if(state.horario == 'verano'){
        horario = ['13', '23'];
      }else{
        horario = ['12', '22'];
      }
      return horario
    }
  },
  mutations : {
    setLanguage (state, lang){
      state.language = lang;
      localStorage.setItem('language', lang);      
    }
  },
  modules :{
    actualidadModule,
    formulariosModule,
    contratacionesModule,
    autoconsumoModule,
    googlePlacesModule
  }
});




// WEBPACK FOOTER //
// ./src/store/store.js